import { styled } from "@mui/system";

export const StyledFormContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2)
}));

export const StyledLabel = styled("p")(({ theme }) => ({
  color: "#373737",
  fontSize: "11px",
  margin: 0
}));

export const StyledLabelContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    display: "none"
  }
}));
